/* global I18n */
import './styles.scss'

import React from 'react'

import Translate from './translate'

import { usedStrings } from './logic'

export const translate = function (scope, options) {
  if (typeof window !== 'undefined' && window.i18nDevMode) {
    usedStrings[scope] = I18n.t(scope, options)
    return <Translate scope={scope} options={options} />
  }

  return I18n.t(scope, options)
}

export const t = translate

export default { ...I18n, t: translate, translate }
